import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  AportacionDIPoseedorControllerService,
  AportacionDiAcuerdosGestoresControllerService,
  PrefacturacionPreviewDTO,
  PrefacturacionRequestDTO,
  PrefacturacionAcuerdosGestoresPreviewDTO,
  PrefacturacionAcuerdosGestoresRequestDTO,
} from 'api-rest';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SpinnerService } from '../../../../services/spinner.service';

export interface PreInvoicingPreviewData {
  modulo: string;
  filtro: PrefacturacionRequestDTO | PrefacturacionAcuerdosGestoresRequestDTO;
}

@Component({
  selector: 'lib-pre-invoicing-preview-modal',
  templateUrl: './pre-invoicing-preview-modal.component.html',
  styleUrls: ['./pre-invoicing-preview-modal.component.scss'],
})
export class PreInvoicingPreviewModalComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalSearch: number = 0;

  esAcuerdoIndirecto: boolean = false;
  entidadLabel: string = 'poseedores';
  entidadLabelSingular: string = 'poseedor';

  headArray: any = [];
  gridArray: any[] = [];

  selectedIds: Set<number> = new Set<number>();

  private fullData: (PrefacturacionPreviewDTO | PrefacturacionAcuerdosGestoresPreviewDTO)[] = [];

  constructor(
    public dialogRef: MatDialogRef<PreInvoicingPreviewModalComponent>,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private aportacionDIPoseedorControllerService: AportacionDIPoseedorControllerService,
    private aportacionDiAcuerdosGestoresControllerService: AportacionDiAcuerdosGestoresControllerService,
    @Inject(MAT_DIALOG_DATA) public data: PreInvoicingPreviewData,
  ) {}

  ngOnInit(): void {
    this.esAcuerdoIndirecto = this.data.modulo === 'ACUERDO_INDIRECTO';
    this.entidadLabel = this.esAcuerdoIndirecto ? 'gestores' : 'poseedores';
    this.entidadLabelSingular = this.esAcuerdoIndirecto ? 'gestor' : 'poseedor';
    this.headArray = [
      {
        Head: '',
        FieldName: 'checked',
        check: true,
        showCheckedAll: true,
        width: '5',
      },
      {
        Head: 'ID',
        FieldName: 'id',
      },
      {
        Head: 'Razón Social',
        FieldName: 'razonSocial',
      },
      ...(this.esAcuerdoIndirecto
        ? [{ Head: 'NIMA', FieldName: 'nima' }]
        : [{ Head: 'Denominación centro', FieldName: 'denominacionCentro' }]),
    ];
    this.buscar();
  }

  buscar(initPage: boolean = false): void {
    if (initPage) {
      this.pageNumber = 0;
    }
    this.spinnerSrv.loadingShow();
    // Cast to a common Observable type: the two service methods return differently-typed
    // overload unions, which makes a ternary's inferred type produce an uncallable subscribe().
    const busqueda$: Observable<(PrefacturacionPreviewDTO | PrefacturacionAcuerdosGestoresPreviewDTO)[]> =
      this.esAcuerdoIndirecto
        ? this.aportacionDiAcuerdosGestoresControllerService.previsualizarPrefacturacion(
            this.data.filtro as PrefacturacionAcuerdosGestoresRequestDTO,
          )
        : this.aportacionDIPoseedorControllerService.previsualizarPrefacturacion(
            this.data.filtro as PrefacturacionRequestDTO,
          );
    busqueda$.subscribe({
      next: (data: (PrefacturacionPreviewDTO | PrefacturacionAcuerdosGestoresPreviewDTO)[]) => {
        this.fullData = data ?? [];
        this.flagSearch = this.fullData.length !== 0;
        this.recordsTotal = this.fullData.length;
        this.totalSearch = this.fullData.length;
        this.renderGrid();
        this.spinnerSrv.loadingHide();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }


  private renderGrid(): void {
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const start = page * this.pageSize;
    const end = start + this.pageSize;
    this.gridArray = this.fullData.slice(start, end).map((item) => ({
      ...item,
      checked: item.id != null && this.selectedIds.has(item.id),
    }));
  }

  renderPage(event: number): void {
    this.pageNumber = event;
    this.renderGrid();
  }

  onItemsPerPageChange(): void {
    this.pageSize = this.selectedItemsPerPage;
    this.pageNumber = 0;
    this.renderGrid();
  }

  checked(item: any): void {
    if (item?.id == null) {
      return;
    }
    if (item.checked) {
      this.selectedIds.add(item.id);
    } else {
      this.selectedIds.delete(item.id);
    }
  }

  allChecked(list: any[]): void {
    for (const item of list) {
      this.checked(item);
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  generar(): void {
    const idPoseedores = Array.from(this.selectedIds);
    if (idPoseedores.length === 0) {
      this.snackBarSrv.showSnackBar(`Debe seleccionar, al menos, un ${this.entidadLabelSingular}`, 'error');
      return;
    }
    this.dialogRef.close(idPoseedores);
  }
}
